import { FC } from "react"
import { ActionFunction, LoaderFunction } from "react-router-dom-7"

export type PageModule<L, A> = {
	loader?: LoaderFunction<L>
	action?: ActionFunction<A>
	Page: FC
}

export function page<L = any, A = any>(lazy: () => Promise<PageModule<L, A>>) {
	return () =>
		lazy().then((m) => {
			return {
				Component: m.Page,
				loader: m.loader,
				action: m.action,
			}
		})
}
